import { isLimitedDevice } from '@/utils/limited-device';
import { useDynamicConfigValue } from './use-dynamic-config-value';
import { useIsFocused } from '@react-navigation/native';

export const useLimitedPerformanceEnabled = () => {
  const limitedAppEnabled = Boolean(
    useDynamicConfigValue('limited_app_enabled'),
  );
  const limitedDevice = isLimitedDevice();

  return Boolean(limitedDevice && limitedAppEnabled);
};

export const useLimitedRenderPage = () => {
  const isFocused = useIsFocused();
  const limitedPerformanceEnabled = useLimitedPerformanceEnabled();

  return isFocused || !limitedPerformanceEnabled;
};
